import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 flex items-center justify-center p-2" }

import { cn } from '@/lib/utils';
    import { X } from 'lucide-vue-next';
    import {
        DialogClose,
        DialogContent,
        type DialogContentEmits,
        type DialogContentProps,
        DialogPortal,
        useForwardPropsEmits,
    } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';
    import DialogOverlay from './DialogOverlay.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DialogContent',
  props: {
    forceMount: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;
    const emits = __emit;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });

    const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogPortal), null, {
    default: _withCtx(() => [
      _createVNode(DialogOverlay, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(DialogContent), _mergeProps({ "data-slot": "dialog-content" }, _unref(forwarded), {
              "aria-describedby": undefined,
              class: 
                        _unref(cn)(
                            'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 relative flex max-h-full w-full flex-col overflow-hidden rounded-lg bg-white shadow-lg duration-200 sm:max-w-lg',
                            props.class,
                        )
                    
            }), {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(_unref(DialogClose), { class: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-5 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(X)),
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Close", -1))
                  ]),
                  _: 1,
                  __: [0]
                })
              ]),
              _: 3
            }, 16, ["class"])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})